import { render } from "./FinalPage.vue?vue&type=template&id=21b8a2d8&scoped=true"
import script from "./FinalPage.vue?vue&type=script&lang=js"
export * from "./FinalPage.vue?vue&type=script&lang=js"

import "./FinalPage.vue?vue&type=style&index=0&id=21b8a2d8&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b8a2d8"]])

export default __exports__